import LayoutChildren from '@/views/LayoutChildren.vue';

const routes = [
  {
    path: '/building_complexes',
    component: LayoutChildren,

    children: [
      {
        path: '',
        name: 'building_complexes',
        component: () => import('../views/BuildingComplexes.vue'),
      },

      {
        path: ':id',
        name: 'building_complexes.show',
        component: () => import('../views/BuildingComplexesShowPage.vue'),
        props: (route) => ({
          id: Number(route.params.id),
          selectedBuilding: Number(route.params.selectedBuilding),
        }),
      },
    ],
  },
];

export default routes;
